// SportsAwards.js
import { Cards } from './Cards.js';
import './css/mycss.css';

import img1 from './images/sp1.png';
import img2 from './images/sp2.png';
import img3 from './images/sp3.png';
import img4 from './images/sp4.png';
import img5 from './images/sp5.png';
import img6 from './images/sp6.png';
import img7 from './images/sp7.png';

/* ----------------- Export Data for Global Search ----------------- */

export const sportsAwardsData = [
  {
    category: "Sports",
    htext: "Major Dhyan Chand Khel Ratna Award",
    ptext: "India’s highest sporting honour for outstanding performance over years.",
    img1,
    ialt: "Major Dhyan Chand Khel Ratna Award",
    modalContent: `
      <b>Established:</b>1991</br>
              <b>Type:</b>Sporting honour for athletes (individuals)<br/>
              <b>First Awarded:</b>1992</br>
              <b>First Recipient: </b>Viswanathan Anand (chess)</br>
              <b> Symbolism:</b>Named after legendary hockey player Major Dhyan Chand — symbolising sporting excellence, sustained brilliance and being a “sporting legend.”</br>
              <b> Awarded For:</b>The “most outstanding performance by a sportsperson” over the preceding four years.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Major_Dhyan_Chand_Khel_Ratna_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Sports",
    htext: "Arjuna Award",
    ptext: "Honours consistent sports excellence over four years.",
    img1: img2,
    ialt: "Arjuna Award",
    modalContent: `
      <b>Established:</b>1961</br>
              <b>Type:</b>Sporting honour (for athletes)<br/>
              <b>First Awarded:</b>1961</br>
              <b>First Recipient: </b>Krishna Das</br>
              <b> Symbolism:</b>Named after Arjuna from Mahabharata — symbol of focus, skill, perseverance and dedication.</br>
              <b> Awarded For:</b>Outstanding performance in sports and games over the previous four years, including good performance at international level, leadership, sportsmanship and discipline.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Arjuna_Award'>wiki link</a></b>
    `
  },
  {
    category: "Sports",
    htext: "Dronacharya Award",
    ptext: "Award for coaches shaping international success for athletes.",
    img1: img3,
    ialt: "Dronacharya Award",
    modalContent: `
      <b>Established:</b>1985</br>
              <b>Type:</b>Sporting honour (for coaches)<br/>
              <b>First Awarded:</b>1985</br>
              <b>First Recipient: </b>Bhalchandra Bhaskar Bhagwat (wrestling), Om Prakash Bhardwaj (boxing), and O. M. Nambiar (athletics)</br>
              <b> Symbolism:</b>Named after the legendary teacher/mentor Dronacharya from Mahabharata — symbolising guidance, mentoring, and the art of training.</br>
              <b> Awarded For:</b>Outstanding and meritorious coaching over a period of years (enabling sportspersons/teams to deliver international-level performances), or lifetime contribution in coaching.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Dronacharya_Award'>wiki link</a></b> 
    `
  },
  {
    category: "Sports",
    htext: "Dhyan Chand Lifetime Achievement Award",
    ptext: "Lifetime award to former athletes who uplift sports beyond their career.",
    img1: img4,
    ialt: "Dhyan Chand Award",
    modalContent: `
      <b>Established:</b>2002</br>
              <b>Type:</b>Lifetime contribution sporting honour (for retired sportspersons)<br/>
              <b>First Awarded:</b>2002</br>
              <b>First Recipient: </b>Shahuraj Birajdar, Ashok Diwan, and Aparna Ghosh</br>
              <b> Symbolism:</b>Named after Major Dhyan Chand — linking lifetime sporting service and legacy with one of India's greatest sports icons.</br>
              <b> Awarded For:</b>Sustained contributions to sports — both during active sporting career and for promotion of sports after retirement (coaching, development, inspiration, etc.).</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Dhyan_Chand_Award'>wiki link</a></b>
    `
  },
  {
    category: "Sports",
    htext: "Maulana Abul Kalam Azad Trophy (MAKA Trophy)",
    ptext: "Award to best-performing sports universities annually.",
    img1: img5,
    ialt: "MAKA Trophy",
    modalContent: `
     <b>Established:</b>1956</br>
              <b>Type:</b>Institutional / University-level sports honour<br/>
              <b>First Awarded:</b>1957</br>
              <b>First Recipient: </b>Bombay University</br>
              <b> Symbolism:</b>Named after Maulana Abul Kalam Azad — India’s first Education Minister, symbolising the link between education and sports / physical education in universities.</br>
              <b> Awarded For:</b>Top overall performance in inter-university sports tournaments during the preceding year — recognising excellence in university-level sporting culture.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Maulana_Abul_Kalam_Azad_Trophy'>wiki link</a></b> 
    `
  },
  {
    category: "Sports",
    htext: "Rashtriya Khel Protsahan Puruskar",
    ptext: "Award for institutions promoting talent, development and welfare in sports.",
    img1: img6,
    ialt: "Rashtriya Khel Protsahan Puruskar",
    modalContent: `
      <b>Established:</b>2009</br>
              <b>Type:</b>Sports-promotion / development honour (for organisations/individuals/boards)<br/>
              <b>First Awarded:</b>2009</br>
              <b>First Recipient: </b>Tata Steel</br>
              <b> Symbolism:</b>The name literally means “National Sports Promotion Award,” symbolising encouragement to institutions/organisations that nurture sports culture beyond just performance — backing the ecosystem behind sporting excellence.</br>
              <b> Awarded For:</b>Making a visible contribution in promotion and development of sports over the past three years — e.g. talent identification, welfare of sportspersons, corporate-social responsibility supporting sports, institutional support, etc.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Rashtriya_Khel_Protsahan_Puruskar'>wiki link</a></b> 
    `
  },
  {
    category: "Sports",
    htext: "Tenzing Norgay National Adventure Award",
    ptext: "Highest Indian award in adventure sports (land / sea / air).",
    img1: img7,
    ialt: "Tenzing Norgay Award",
    modalContent: `
    <b>Established:</b>1993</br>
              <b>Type:</b>Adventure sports / sporting honour<br/>
              <b>First Awarded:</b>1994</br>
              <b>First Recipient: </b>mountaineer Bachendri Pal (Land Adventure), A. K. Singh (Water Adventure), Rachel Thomas (Air Adventure), and Hukum Singh (Lifetime Achievement).</br>
              <b> Symbolism:</b>Named after Tenzing Norgay — the legendary mountaineer who was among the first two humans to scale Mount Everest (1953) — symbolising courage, adventure spirit, and pushing boundaries.</br>
              <b> Awarded For:</b>Outstanding achievement in the field of adventure activities (land, sea, air) over the preceding three years; or lifetime contribution to adventure sports and promotion of adventurous spirit.</br> 
              <br/><b><a href='https://en.wikipedia.org/wiki/Tenzing_Norgay_National_Adventure_Award'>wiki link</a></b> 
    `
  }
];

/* ----------------- Page UI ----------------- */

export default function SportsAwards() {
  return (
    <div>
      <h1 className="heading">Sports Awards</h1>
      <h3 className="head2">“Honouring dedication and performance in Indian sport.”</h3>

      <div className="search-cards-container">
        {sportsAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
